export default __webpack_public_path__ + "static/media/MonPharmacien-App.fbea5646.png";